import { render, staticRenderFns } from "./instant.vue?vue&type=template&id=bb48592a&"
import script from "./instant.vue?vue&type=script&lang=js&"
export * from "./instant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports